import { Component } from "@angular/core";

@Component({
    templateUrl: "./hubber-practice.component.html"
})
export class HubberPracticeComponent {

}